import React from 'react';
import { string, object } from 'prop-types';
import classNames from 'classnames';
import NamedLink from '../NamedLink/NamedLink';
import { formatCaseStudyPrismicData } from '../../util/data';
import css from './CaseStudyCard.module.css';

const options = { year: 'numeric', month: 'long', day: 'numeric' };

const CaseStudyCard = props => {
  const { rootClassName, className, caseStudy } = props;
  const classes = classNames(rootClassName || css.root, className);
  const { slug, postDate, title, image, alt } = formatCaseStudyPrismicData(caseStudy);

  return (
    <div className={classes}>
      <NamedLink name="CaseStudyPage" params={{ slug }} className={css.square}>
        <img src={image} loading="lazy" alt={alt} />
      </NamedLink>
      <NamedLink name="CaseStudyPage" params={{ slug }} className={css.title}>
        {title}
      </NamedLink>
      <div className={css.postDate}>
        {postDate?.toLocaleDateString('en-US', options)}
      </div>
    </div>
  );
};

CaseStudyCard.propTypes = {
  rootClassName: string,
  className: string,
  image: string,
  title: string,
  postDate: object,
  slug: string,
};

CaseStudyCard.defaultProps = {
  rootClassName: null,
  className: null,
  image: null,
  title: null,
  postDate: null,
  slug: null,
};

export default CaseStudyCard;
